import React from 'react'
import { getSession, login as loginRequest, logout as logoutRequest } from '../services/auth/authApi'
import { clearApplicationSession, setApplicationSession } from '../services/applicationSession'

const AuthContext = React.createContext(null)

export const AuthProvider = ({ children }) => {
  const [session, setSession] = React.useState(null)
  const [loadingSession, setLoadingSession] = React.useState(true)

  const cargarSesion = React.useCallback(async () => {
    setLoadingSession(true)

    try {
      const sessionResponse = await getSession()
      setApplicationSession(sessionResponse)
      setSession(sessionResponse)
      return sessionResponse
    } catch (error) {
      clearApplicationSession()
      setSession(null)
      throw error
    } finally {
      setLoadingSession(false)
    }
  }, [])

  React.useEffect(() => {
    cargarSesion().catch(() => {
      setLoadingSession(false)
    })
  }, [cargarSesion])

  const login = React.useCallback(async ({ login, password }) => {
    const sessionResponse = await loginRequest({ login, password })
    setApplicationSession(sessionResponse)
    setSession(sessionResponse)
    return sessionResponse
  }, [])

  const logout = React.useCallback(async () => {
    try {
      await logoutRequest()
    } finally {
      clearApplicationSession()
      setSession(null)
    }
  }, [])

  const value = React.useMemo(() => ({
    session,
    loadingSession,
    authenticated: Boolean(session),
    cargarSesion,
    login,
    logout,
  }), [cargarSesion, loadingSession, login, logout, session])

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const context = React.useContext(AuthContext)

  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider')
  }

  return context
}
